import { BannerStatus } from "@plex/react-components";

import { IMessageId, ILocalizable } from "infrastructure/localization";

import { INotification, INotificationContentBuilder } from "./notification.types";

const notificationContentBuilder = (notification: INotification): INotificationContentBuilder => {
  const currentNotification = { ...notification };

  return {
    useMessage: (message: ILocalizable): INotification => {
      currentNotification.content = [{ message }, ...currentNotification.content];

      return currentNotification;
    },
    useMessageId: (messageId: IMessageId): INotification => {
      currentNotification.content = [{ message: { messageId } }, ...currentNotification.content];

      return currentNotification;
    },
    useMessages: (messages: ILocalizable[]): INotification => {
      currentNotification.content = [...messages.map(message => ({ message })), ...currentNotification.content];

      return currentNotification;
    },
    get: () => {
      return currentNotification;
    }
  };
};

const notificationProvider = () => {
  return {
    create: (type: BannerStatus): INotificationContentBuilder => {
      return notificationContentBuilder({
        type: type,
        content: []
      });
    },
    success: (): INotificationContentBuilder => {
      return notificationContentBuilder({
        type: BannerStatus.success,
        content: []
      });
    },
    warning: (): INotificationContentBuilder => {
      return notificationContentBuilder({
        type: BannerStatus.warning,
        content: []
      });
    },
    error: (error?: Error): INotificationContentBuilder => {
      return notificationContentBuilder({
        type: BannerStatus.error,
        content: error
          ? [
              {
                error
              }
            ]
          : []
      });
    }
  };
};

export const notification = notificationProvider();
